import SledovanyLegislativnyMaterialListPage from './SledovanyLegislativnyMaterialListPage';

export default SledovanyLegislativnyMaterialListPage;
